import { PitcherSessionReportChartConfigDto, PitcherStatsByPitchType, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const disabledVisibleStats: (keyof PitcherStatsByPitchType)[] = ['pitchType'];

const PitcherSessionStatsByPitchTypeChartSidebar = (props: ChartConfigProps<TableChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return (
    <TableChartSidebar
      chartId='PitcherSessionStatsByPitchTypeChart'
      configKey='pitcherSessionStatsByPitchTypeChartConfig'
      {...props}
      disabledVisibleStats={disabledVisibleStats}
    />
  );
};

export default PitcherSessionStatsByPitchTypeChartSidebar;
